import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const reportG4 = {
    getReportData,
    getReportDataFixed,
    getServiceRegulate,
    getServiceRegulateList,
    getPropotionMobileService,
    getAllProviderByType
};

function getReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getReportData/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getReportDataFixed(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getReportDataFixed/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getServiceRegulate(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getServiceRegulate/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getServiceRegulateList() {
    let user_nbtc = Cookie.get('user_nbtc');
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getServiceRegulateList/?authorization=" + json_cookie.token)
        .then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

function getPropotionMobileService(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getPropotionMobileService/?authorization=" + json_cookie.token)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getAllProviderByType(data){
    let user_nbtc = Cookie.get('user_nbtc');
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportG4/getAllProviderByType/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err) 
            })
    })
}